const countrySelect = document.getElementById(
  "disclaimer-country-select"
) as HTMLSelectElement | null;
const continueButton = document.getElementById(
  "disclaimer-continue-button"
) as HTMLButtonElement | null;

if (countrySelect && continueButton) {
  const updateContinueButtonState = () => {
    continueButton.disabled = !countrySelect.value;
  };

  updateContinueButtonState();

  countrySelect.addEventListener("change", updateContinueButtonState);

  // Browsers can restore a previously chosen <select> value when navigating back (either from
  // bfcache, or plain form-state restoration on a fresh reload) without firing a "change" event,
  // and this can happen after the above initial check already ran - leaving the button stuck in
  // whatever disabled state it started in. "pageshow" fires after any such restoration completes,
  // covering both cases.
  window.addEventListener("pageshow", updateContinueButtonState);
}
